import { NewBadge } from "@certn/cascadia-react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useTranslation } from "react-i18next";

export function MonitoringNewBadge() {
  const { t } = useTranslation();
  const { clientPortalEnableContinuousMonitoring } = useFlags();

  if (!clientPortalEnableContinuousMonitoring) {
    return null;
  }

  return (
    <NewBadge
      type="bold"
      testID="monitoring-new-badge"
      size="large"
      padding="space-05"
    >
      {t("New")}
    </NewBadge>
  );
}
